import routersManager from "@/managers/routers.manager";
import { Route } from "@/model/route.model";
import appVersion from "../../version.js";

import { defineComponent } from "vue";

export default defineComponent({
    name: "HomeComponent",
    data() {
        return {
            routes: [],
            title: "Descubre Madrid y sus distritos",
            description: `Explora las maravillas de Madrid a través de neustras ` +
            `rutas interactivas y surmérgete en la historia y cultura de cada distrito`,
            appVersion: appVersion
        }
    },
    async mounted() {
        this.routes = await routersManager.getRouters();
    },
    methods: {
        goToRoute(route: Route): void {
            this.$router.push({ name: "route", params: { name: route.name.replace(/ /g, '_') } });
        },
        scrollToTop(): void {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
})